export const categories = {
    1: 'Футболки и жилеты',
    2: 'Рубашки',
    3: 'Шорты',
    4: 'Худи',
    5: 'Свитшоты',
    6: 'Куртки и ветровки',
    7: 'Джинсы',
    8: 'Джемперы и кордиганы',
    9: 'Носки',
    10: 'Нижнее белье',
    11: 'Обувь',
    12: 'Носки',
    13: 'Кроссовки',
    14: 'Сандали',
    15: 'Лоферы',
    16: 'Брюки',
    17: 'Джогеры',
    18: 'Костюмы',
    19: 'Сумки',
    20: 'Шоперы',
    21: 'Акссесуары',
}

export const Links = [
    {
        id: 1,
        category: 'Футболки',
    },
    {
        id: 4,
        category: 'Толстовки',
    },
    {
        id: 13,
        category: 'Обувь',
    },
    {
        id: 12,
        category: 'Сумки',
    },
    {
        id: 1,
        category: 'Носки',
    },
    {
        id: 1,
        category: 'Куртки',
    },
    {
        id: 1,
        category: 'Нижнее',
    },
    {
        id: 1,
        category: 'Худи',
    },
    {
        id: 1,
        category: 'Аксессуары',
    },
    {
        id: 1,
        category: 'Подарки',
    },
    {
        id: 1,
        category: 'Шляпы',
    },
]
